<div #origin="rtOverlayOrigin" rt-overlay-origin class="origin">
  @if (variant() === 'input') {
    <rt-input
      [readOnly]="true"
      [disabled]="disabled()"
      [placeholder]="placeholder()"
      [hasDropdownIndicator]="!value()"
      [hasClearButton]="!!value() && !disabled()"
      [value]="display() ?? ''"
      [class.dropdownOpened]="dropdownOpened()"
      (click)="!disabled() && toggleDropdown()"
      (reset)="clear(); $event.stopPropagation()"
      variant="rounded"
      class="no-focus-input"
    >
      <rt-icon prefix [name]="effectiveIcon()" />
    </rt-input>
  } @else {
    <rt-button
      [disabled]="disabled()"
      [rtProtectedControl]="protectedControl()"
      (click)="toggleDropdown()"
      variant="plain"
    >
      <rt-icon [name]="effectiveIcon()" size="small" />
      <span>{{ display() || emptyLabel() }}</span>
    </rt-button>
  }
</div>

@if (variant() === 'button' && !!value() && !disabled()) {
  <rt-icon-button
    (click)="clear()"
    variant="plain"
    iconName="close"
    shape="square"
    margin-left-small-xx
  />
}

<ng-template
  #picker="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="origin"
  [positions]="dropdownPositionPairs"
  [withPush]="false"
  [growAfterOpen]="true"
  [open]="dropdownOpened()"
  (backdropClick)="toggleDropdown()"
>
  <rt-due-date-picker
    [showTimezone]="showTimezone()"
    [timezone]="pickerTimezone()!"
    [dueDateType]="pickerType()!"
    [dueDateUnit]="pickerUnit()!"
    [dueDateValue]="pickerValue()!"
    [relativeLabel]="relativeLabel()"
    [submitLabel]="submitLabel()"
    (valueChanges)="onSelect($event)"
    (typeChange)="onTypeChange()"
  />
</ng-template>
